module.exports = __webpack_public_path__ + "static/img/ks_code.5e11ac87.png";